<template>
  <div class="date-picker-container">
    <span
      :class="[value ? '' : 'placeholder']"
    >
      {{ formattedDate }}
      <img
        v-if="!hideIcon"
        src="@shared/assets/img/table/calendar.png"
        class="calendar"
        alt="Calendar"
      >
    </span>
    <div class="date-picker">
      <Datepicker
        :value="value"
        :minDate="minDate"
        :popover="{ placement: 'bottom', visibility: 'click' }"
        :maxDate="maxDate"
        @input="$emit('input', $event)"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import Datepicker from 'v-calendar/lib/components/date-picker.umd';

export default {
  name: 'DatePicker',
  components: {
    Datepicker,
  },
  props: {
    hideIcon: Boolean,
    value: [Date, String],
    minDate: Date,
    maxDate: Date,
    label: String,
  },
  computed: {
    formattedDate() {
      if (this.value) {
        return moment(this.value).format('YYYY-MM-DD');
      }
      return this.label ? this.label : 'Select Date';
    },
  },
};
</script>

<style lang="scss" scoped>

.date-picker-container {
  position: relative;
  height: 48px;
  border: 1px solid $NBLUE10;
  border-radius: 8px;
  padding-left: 12px;
  width: 100%;
  span {
    display: flex;
    align-items: center;
    height: 100%;
    position: relative;
    .calendar {
      width: 10.8px;
      height: 12px;
      position: absolute;
      right: 11px;
    }
    .cancel {
      width: 15px;
      height: 15px;
      position: absolute;
      right: 11px;
      cursor: pointer;
      z-index: 5;
    }
    &.placeholder {
      color: $N30;
      font-weight: 500;
    }
  }
  .date-picker {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    input {
      opacity: 0;
      cursor: pointer;
      color: $BLACK;
    }
  }
}
</style>
